// src/components/Modals/DeleteConfirmationModal.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ModalBase.css';
import { FaTimes } from 'react-icons/fa';

export default function DeleteConfirmationModal({ onClose, onConfirm }) {
  const navigate = useNavigate();

  const handleDelete = () => {
    if (onConfirm) {
      // Если передан onConfirm, выполняем его
      onConfirm();
    } else {
      // Иначе — просто навигейт назад (как было раньше)
      navigate(-1);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-window poi">
        {/* Кнопка закрытия */}
        <button className="modal-close-btn" onClick={onClose}>
          <FaTimes />
        </button>

        {/* Заголовок */}
        <h2 className="modal-title">Удаление записи</h2>

        {/* Описание */}
        <div className="modal-form">
          <p className="modal-delete-text">
            Вы уверены, что хотите удалить запись? Запись будет удалена без возможности восстановления.
          </p>
        </div>

        {/* Действия */}
        <div className="modal-actions">
          <button className="modal-button cancel" onClick={onClose}>
            Отмена
          </button>
          <button className="modal-button delete" onClick={handleDelete}>
            Удалить
          </button>
        </div>
      </div>
    </div>
  );
}
